import { createStore } from 'satcheljs';
import { ErrorStore } from '../schema/ErrorStore';

const errorState: ErrorStore = {
    globalError: false,
    errorSource: null,
    errorTitle: '',
};

export const getGlobalErrorState = createStore<ErrorStore>('errorStore', errorState);
export default getGlobalErrorState();
